// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-0b5ae54b]{background-color:var(--v-primary-base)!important;border-radius:50px;color:#fff}@media (min-width:960px){.sticky-preview[data-v-0b5ae54b]{position:sticky;top:0!important;-ms-flex-item-align:start;align-self:flex-start;height:-webkit-max-content;height:-moz-max-content;height:max-content;z-index:4}}.qr-floating-btn[data-v-0b5ae54b]{position:absolute;top:14px;left:14px;z-index:20;background-color:hsla(0,0%,100%,.9)!important}", ""]);
// Exports
module.exports = exports;
